import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-obemaptopic',
  templateUrl: './obemaptopic.component.html',
  styleUrls: ['./obemaptopic.component.scss'],
   providers:[MasterService]
})
export class ObemaptopicComponent implements OnInit {

  
      memberdetails:any[]=[];
      classdetails:any[]=[];
      arrashead:any=[];
      arrastype:any=[];
      closeResult: string;
      classes: any=[];
      section: any=[];
      arrcourse:any=[];
      arrsubcomb:any=[];
      student:boolean=true;
      staff:boolean=false;
      memberdash:any={};
      objass:any={};
      objastype:any={};
      objfilt:any={};
      objfilt1:any={};
      arreval:any=[];
      arrevpatern:any=[];
      arrcat:any=[];
      arract:any=[{name:'Yes'},{name:'No'}];
      arrledom:any=[{name:'Cognitive'},{name:'Affective'},{name:'Psychomotor'}];
      arrcltype:any=[{id:'L',name:'Lecture'},{id:'T',name:'Theory'},{id:'P',name:'Practical'}];
      objmethod:any={};
      objpo:any={};
      objlevel:any={};
      objco:any={};
      modalOptions:NgbModalOptions;
      private modalRef: NgbModalRef;
  arrbatch: any=[];
  objfilt3: any={};
  arrbatchorg: any=[];
    
      constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
    
      open(content) {
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    
      private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
          return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
          return 'by clicking on a backdrop';
        } else {
          return `with: ${reason}`;
        }
      }
    
    
    
      ngOnInit(): void {
        
        this.getcourses();

        this.getobemlevels();
        this.getobempo(0);
        this.getobemtmethod();
      }
    
    
      // masclass() {
      //   this.mservice.masclass()
      //       .subscribe(
      //       resultArray => {
      //           console.log('getdashcounts', resultArray);
      //           this.classes = resultArray;
      //           this.objfilt.clid=resultArray[0].clid;
      //           // this.getobemco(this.objfilt);
      //           this.SelectClsSubDetails();
      //       },
      //       error => console.log("Error :: " + error)
      //       )
      // }

      masclass() {
      this.mservice.classmasterrolewise(0,this.objfilt.crid,0,'class')
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.objfilt.clid=resultArray[0].clid;
              this.objfilt1.clid=resultArray[0].clid;
              this.SelectClsSubDetails();
            //  this.masperiod();
              
             
          },
          error => console.log("Error :: " + error)
          )
    }
    
      private getcourses() {
    
        this.mservice.getcourse()
      .subscribe((result:any) => {
      
      this.arrcourse=result;
      this.objfilt.crid=result[0].crid;
      this.objfilt1.crid=result[0].crid;
      this.masclass();
      this.getobempo(this.objfilt.crid);
      
      }, error => {
      
      //alert('error in r');
      // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
      }
      );
        
        
      }
    
      Getsubcomb()
      {
        debugger
        this.mservice.sel_sp_exmsubcomb()
        .subscribe(
          
         resultArray =>{
          console.log('result',resultArray) ;
          this.objfilt.sucbid=resultArray[0].sucbid;
          //this.clsdate=resultArray;
          this.arrsubcomb = resultArray;
          //this.getevpattern();
          },
         error => console.log("Error :: " + error)
      )
      }
       
    
      evalfilters()
      {
        this.masclass();
        this.getcourses();
        this.Getsubcomb();
      }
      massection() {
        this.mservice.massection()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.section = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
          getobempo(crid) {
        this.mservice.getobempo(crid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrashead = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
         getobemtmethod() {
        this.mservice.getobemtmethod()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrcat = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
       getobemco(obj) {
        this.mservice.getobemco(obj)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrevpatern = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }

       getobemtpmap(obj) {
        debugger
        this.mservice.getobemtpmap(obj)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arreval = resultArray;
               
            },
            error => console.log("Error :: " + error)
            )
      }
  
      getobemlevels() {
    
        // console.log('objfilt',this.objfilt);
        //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
        this.mservice.getobemlevels()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrastype=resultArray;
                // if(oprtype=="selpo")
                // {
                //  this.arrashead=resultArray;
                // }
                // else if (oprtype=="selblchart")
                // {
                //   this.arrastype=resultArray;
                // }
                // else if (oprtype=="selco")
                // {
                // this.arrevpatern = resultArray;
                // }
               
            },
            error => console.log("Error :: " + error)
            )
      }
    
      SelectClsSubDetails() {
        debugger
        //var clid = this.clid;
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        var clssubdata = { clid:this.objfilt.clid,clcd:clcd,aycd:aycd,crid:this.objfilt.crid };
        console.log('model', clssubdata);
        // this.mservice.masclasssubject(clssubdata)
        this.mservice.subjectsrolewise(0,0,this.objfilt.clid,'asaa',this.objfilt.crid)
            .subscribe(resultArray => {
                console.log('classsubs', resultArray);
                this.arrsubcomb = resultArray;
                this.objfilt.suid=resultArray[0].suid;
                this.getobemtpmap(this.objfilt);
                this.getobempo(this.objfilt.crid);
                //alert (resultArray.message);
    
            }, error =>
                alert('error in connection')
            );
        //this.closeAddExpenseModal.nativeElement.click();
    }
      

     SelectClsSubDetails3() {
        debugger
        //var clid = this.clid;
        let clcd=localStorage.getItem('clcd');
        let aycd=localStorage.getItem('aycd');
        var clssubdata = { clid:this.objfilt3.clid,clcd:clcd,aycd:aycd,crid:this.objfilt.crid };
        console.log('model', clssubdata);
        // this.mservice.masclasssubject(clssubdata)
        this.mservice.subjectsrolewise(0,0,this.objfilt.clid,'asaa',this.objfilt.crid)
            .subscribe(resultArray => {
                console.log('classsubs', resultArray);
                this.arrsubcomb = resultArray;
                this.objfilt.suid=resultArray[0].suid;
                this.getobemtpmap(this.objfilt);
                this.getobempo(this.objfilt.crid);
                //alert (resultArray.message);
    
            }, error =>
                alert('error in connection')
            );
        //this.closeAddExpenseModal.nativeElement.click();
    }
      
     
      getevpattern(oprtype,suid) {
    
        console.log('objfilt',this.objfilt);
        //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
        this.mservice.getevlcopomaster(oprtype,suid)
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                if(oprtype=="selpo")
                {
                 this.arrashead=resultArray;
                }
                else if (oprtype=="selblchart")
                {
                  this.arrastype=resultArray;
                }
                else if (oprtype=="selco")
                {
                this.arrevpatern = resultArray;
                }
               // this.fmodel.asstypeId=resultArray[0].astpid;
            },
            error => console.log("Error :: " + error)
            )
      }
    
      
     
  
      
     
      
    
   opencondelete(objdata)
   {
     this.objlevel=objdata;
     this.objlevel.active='No';
          this.objlevel.oprtype='delete';

    // console.log('saveobj',this.objlevel);
    if(confirm("Are you sure want to delete?"))
    {
      this.mservice.save_obemtpmap(this.objlevel)
          .subscribe(
          result => {
              console.log('SavegenmasDetails', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
              //  this.masasstype();
             this.getobemtpmap(this.objfilt);
              }
             else
             {
    
             }
          },
          error =>{ alert('Error While saving...');}
          )
        }
   }
  
  
   
     openhodrmks(content,objdata) {
        debugger
        // this.getobemco(this.objfilt);
        
        
       
          this.objass=objdata;
          this.objass.oprtype='hod_rmks';
       
        
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'sm'
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
  
      
      upd_obemtpmap_rmks()
    {
    console.log('saveobj',this.objass);
      this.mservice.upd_obemtpmap_rmks(this.objass)
          .subscribe(
          result => {
              console.log('SavegenmasDetails', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
              //  this.masasstype();
             this.getobemtpmap(this.objfilt);
              }
             else
             {
    
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }

  
  
  
     openlevels(content,objdata,cmd) {
        debugger
        this.getobemco(this.objfilt);
        
        
        if(cmd=='insert')
        {
          this.objlevel={};
         
          
          
          this.objlevel.tpid='0';
          this.objlevel.tpnm='';
          this.objlevel.duration=0;
          this.objlevel.poid=this.arrashead[0].poid;
          
          this.objlevel.leid=this.arrastype[0].leid;
          this.objlevel.meid=this.arrcat[0].meid;
           this.objlevel.active='Yes';
           this.objlevel.cltype='L';
            this.objlevel.pldt=this.mservice.getdatetoday();
         
          this.objlevel.oprtype='insert';
          this.objlevel.clid=this.objfilt.clid;
          this.objlevel.crid=this.objfilt.crid;
          this.objlevel.suid=this.objfilt.suid;
          // if(this.arrevpatern.length>0)
          if(this.arrevpatern)
          {
         this.objlevel.coid=this.arrevpatern[0].coid;
          }
        }
      
        else if(cmd=='update')
        {
          this.objlevel=objdata;
          this.objlevel.oprtype='update';
        }
        
        this.modalOptions = {
          backdrop:'static',
          backdropClass:'customBackdrop',
          size:'lg'
         
        }
        this.modalRef=this.modalService.open(content,this.modalOptions);
        
        this.modalRef.result.then((result) => {
       
             
          }, (reason) => {
              
          });
      }
  
  
      save_obemlevels()
    {
    console.log('saveobj',this.objlevel);
      this.mservice.save_obemtpmap(this.objlevel)
          .subscribe(
          result => {
              console.log('SavegenmasDetails', result);
              //this.suppliers = resultArray;
              alert(result.message);
              if(result.status=='success')
              {
                let localmodref=this.modalRef;
                localmodref.close();
              //  this.masasstype();
             this.getobemtpmap(this.objfilt);
              }
             else
             {
    
             }
          },
          error =>{ alert('Error While saving...');}
          )
    }


    
 printcertificate(){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

   var url=this.mservice.callurl+"/fpdf181/pdfreports/colessonplan.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.objfilt.clid+"&crid="+this.objfilt.crid+"&suid="+this.objfilt.suid;

   window.open(url,'');
  
 }

   private getobeoverview() {
  
      this.mservice.getobeoverviewstaff(this.objfilt1)
    .subscribe((result:any) => {
    
    this.arrevpatern=result;
   
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }


     getbatches() {
        this.mservice.getbatches()
            .subscribe(
            resultArray => {
                console.log('getdashcounts', resultArray);
                this.arrbatchorg = resultArray;
                // this.arrbatch=Array.from(new Set(this.arrbatchorg.map(user =>({cbclid: user.cbclid, cbclnm: user.cbclnm}))));
              this.arrbatch=  this.arrbatchorg.filter(
  (user, index, self) => self.findIndex(u => u.id === user.id) === index
);
                console.log('getdashcounts', this.arrbatch);
                this.objfilt3.btid=this.arrbatch[0].cbclid;
               
            },
            error => console.log("Error :: " + error)
            )
      }

      // getsemester(btid)
      // {
      //   this.classes=this.arrbatchorg.filter(user => user.isActive)

      // }
    
    }
    
  
